import { render, staticRenderFns } from "./projectParticipantsOverview.vue?vue&type=template&id=38d7bcda"
import script from "./projectParticipantsOverview.vue?vue&type=script&lang=js"
export * from "./projectParticipantsOverview.vue?vue&type=script&lang=js"
import style0 from "./projectParticipantsOverview.vue?vue&type=style&index=0&id=38d7bcda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports